import { useState } from 'react';

import { RateAndReviewModal } from '../rateAndReviewModal/rateAndReviewModal';
import type { RateAndReviewModalVariantProps } from '../rateAndReviewModalVariant';
import { RateAndReviewWizard } from '../rateAndReviewWizard/rateAndReviewWizard';
import { ReviewProductHeader } from '../reviewProductHeader/reviewProductHeader';
import { ReviewSubmitted } from '../reviewSubmitted/reviewSubmitted';

export type RateAndReviewWizardModalProps = RateAndReviewModalVariantProps;

/**
 * A/B test variant B: the modal shell with one question per step.
 * Owns the current step and restarts from the first step whenever a review
 * starts: on open, and when the next product is picked from the confirmation.
 */
export function RateAndReviewWizardModal({
  activityOptions,
  brand,
  category,
  feelingOptions,
  imageUrl,
  isMobile,
  isSubmitted = false,
  isSubmitting,
  moreToReview,
  onChange,
  onRequestClose,
  onReviewProduct,
  onSubmit,
  open,
  productName,
  testId,
  title,
  value,
}: RateAndReviewWizardModalProps) {
  const [step, setStep] = useState(0);
  const isShowingForm = open && !isSubmitted;
  const [wasShowingForm, setWasShowingForm] = useState(isShowingForm);

  if (isShowingForm !== wasShowingForm) {
    setWasShowingForm(isShowingForm);
    if (isShowingForm) setStep(0);
  }

  return (
    <RateAndReviewModal
      isMobile={isMobile}
      onBack={
        step > 0 && !isSubmitting && !isSubmitted
          ? () => setStep(step - 1)
          : undefined
      }
      onRequestClose={onRequestClose}
      open={open}
      productHeader={
        !isSubmitted && (
          <ReviewProductHeader
            brand={brand}
            category={category}
            imageUrl={imageUrl}
            name={productName}
            size="compact"
          />
        )
      }
      testId={testId}
      title={title}
    >
      {isSubmitted ? (
        <ReviewSubmitted
          moreToReview={moreToReview}
          onDone={onRequestClose}
          onReviewProduct={onReviewProduct}
          productName={productName}
          rating={value.rating}
        />
      ) : (
        <RateAndReviewWizard
          activityOptions={activityOptions}
          feelingOptions={feelingOptions}
          isSubmitting={isSubmitting}
          onChange={onChange}
          onStepChange={setStep}
          onSubmit={onSubmit}
          step={step}
          value={value}
        />
      )}
    </RateAndReviewModal>
  );
}
